import React from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import FabricBadge from '../components/FabricBadge';
import { Link } from 'react-router-dom';
import { CheckCircleFill } from 'react-bootstrap-icons';

const values = [
  'Machine identities are the largest unsolved security problem in enterprise infrastructure — and the one growing fastest.',
  'Ephemeral, policy-driven credentials are better than persistent secrets in every dimension. We make them the default.',
  'Visibility before enforcement. You can\'t govern what you can\'t see — the identity graph comes before the policy engine.',
  'Incremental adoption. We integrate with your existing IAM, PAM, and secrets infrastructure — no forklift migrations.',
  'Zero overhead on live traffic. Arkodomo manages identity at provisioning time — no latency impact, no failure mode added to production systems.',
  'Customer-hosted, customer-controlled. Your infrastructure, your perimeter. No inbound access required.',
  'The perimeter is identity — and machines now outnumber people by orders of magnitude.',
];

function About() {
  return (
    <Container className="py-5 text-light">
      <Row className="mb-5">
        <Col lg={8}>
          <h1 className="h2 fw-bold mb-2">About Arkodomo</h1>
          <div className="mb-3"><FabricBadge /></div>
          <p className="text-white-50 mb-0">
            Arkodomo is building the identity broker for the AI era. As non-human identities — service accounts, AI agents, workload credentials, CI/CD runners — multiply across enterprise environments, the tools built for human IAM fall catastrophically short. We're fixing that: a purpose-built platform that provisions, maps, detects, and enforces machine identity lifecycle at scale.
          </p>
        </Col>
      </Row>

      <Row className="g-4 mb-5">
        <Col lg={8}>
          <h2 className="h4 section-heading mb-4">What We Believe</h2>
          <ul className="check-icon-list">
            {values.map((v, i) => (
              <li key={i}><CheckCircleFill size={15} /><span>{v}</span></li>
            ))}
          </ul>
        </Col>
      </Row>

      <Row className="g-4 mb-5">
        <Col lg={8}>
          <h2 className="h4 section-heading mb-4">People</h2>
          <Card bg="dark" text="light" className="border-0 shadow-sm">
            <Card.Body className="d-flex align-items-start gap-4 p-4">
              <img src={`${process.env.PUBLIC_URL}/img/P1.png`} alt="CEO and Founder" className="person-photo flex-shrink-0" />
              <div>
                <Card.Title className="mb-1">Founder & CEO</Card.Title>
                <Card.Text className="text-white-50 mb-3">
                  Building Arkodomo to make machine identity governance as rigorous as human identity governance — because the machines have already won the numbers game. The security infrastructure needs to catch up.
                </Card.Text>
                <div className="d-flex gap-2">
                  <Link to="/contact" className="btn btn-primary btn-sm">Get in touch</Link>
                  <a className="btn btn-outline-light btn-sm" href="https://www.linkedin.com/in/huvelez" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-4">
        <Col lg={8}>
          <h2 className="h5 section-heading mb-3">Arkodomo Fabric</h2>
          <p className="text-white-50 mb-0">The platform is built on <strong>Arkodomo Fabric</strong> — the underlying policy, issuance, and audit layer that powers every integration and enforcement action. Fabric is the abstraction that makes a single policy model work across heterogeneous environments.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default About;
